import styled from 'styled-components';

import { alignMiddle } from '~src/styles/utils/positioning';

export const Header = styled.header<{ $caretSize: number }>`
  position: relative;
  padding-right: ${({ $caretSize }) => $caretSize + 50}px;
  cursor: pointer;
`;

export const CaretBox = styled.div`
  ${alignMiddle};
  right: 30px;
`;

export const ContentContainer = styled.div<{ $timeout: number; $maxHeight?: number }>`
  max-height: 0;
  overflow: hidden;
  transition: max-height ${({ $timeout }) => $timeout}ms;

  &.enter-active,
  &.enter-done {
    max-height: max-content;
  }
`;
